import { LIMIT_FREE } from "../../types/subscription";
import { PageType } from "../../types/Page";
import { useUserQuery } from "../User/UserService.hooks";
import { useGetPageLazyQuery } from "./PageService.hooks";

export enum PublishLimitModalType {
  PublishLimit = "publishLimit",
  PublishSubpagesLimit = "publishSubpagesLimit",
}

export const usePublishSubpagesLimit = () => {
  const { refetch: refetchUser } = useUserQuery();
  const [fetchPage] = useGetPageLazyQuery({ fetchPolicy: "no-cache" });

  const getPublishLimitModal = async (page: PageType | null): Promise<PublishLimitModalType | null> => {
    const fallback = page?.canPublish ? null : PublishLimitModalType.PublishLimit;
    if (!page?.id || !page.rootPage || !page.subPages.length) return fallback;

    try {
      const [{ data: userData }, { data: pageData }] = await Promise.all([
        refetchUser(),
        fetchPage({ variables: { id: page.id } }),
      ]);
      const user = userData?.user;
      if (!user || user.admin || user.activePremium) return fallback;

      if (pageData?.page?.canPublish ?? page.canPublish) return null;

      return user.countPublishPages >= LIMIT_FREE.PUBLISHED_PAGE
        ? PublishLimitModalType.PublishLimit
        : PublishLimitModalType.PublishSubpagesLimit;
    } catch (error) {
      console.error(error);
      return fallback;
    }
  };

  return { getPublishLimitModal };
};
